export default "__VITE_ASSET__B1gZJ17B__"